<template>
    <div class="con">
        <div class="select-row" v-if="fir">
            <select class="select" v-model="dataObj.year" @change="yearOrMonthSel">
                <option value="">年</option>
                <option v-for="item in yearOp" :key="item" :value="item">{{ item }}</option>
            </select>
            <select class="select" v-model="dataObj.month" @change="yearOrMonthSel">
                <option value="">月</option>
                <option v-for="item in monthOp" :key="item" :value="item">{{ item }}</option>
            </select>
            <template v-if="dateShow">
                <select class="select" v-model="dataObj.date" @change="dateSel">
                    <option value="">日</option>
                    <option v-for="(item, index) in dateOp" :key="index" :value="item">{{ item }}</option>
                </select>
            </template>
        </div>

        <div class="tips" v-if="second">
            <i></i>
            {{ readDateTimeComputed }}
            <!-- 密码中必须包含大小写字母、数字、特殊字符，至少8个字符，最多32个字符 -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fir: {
            type: Boolean,
            default: true
        },
        second: {
            type: Boolean,
            default: false
        },
        initDateTime: {
            type: Number,
            default: null
        },
        dateShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dataObj: {
                year: '',
                month: '',
                date: ''
            },
            yearOp: [],
            monthOp: [],
            dateOp: []
        }
    },
    computed: {
        readDateTimeComputed() {
            let src = `${this.dataObj.year} - ${this.dataObj.month}`
            if (this.dateShow) {
                src += ` - ${this.dataObj.date}`
            }
            return src
        }
    },
    watch: {
        'dataObj.year'(newVal, oldVal) {
            this.getDateOp()
        },
        'dataObj.month'(newVal, oldVal) {
            this.getDateOp()
        },
        initDateTime(newVal, oldVal) {
            this.initDate(newVal)
        }
    },
    created() {
        this.initDate(this.initDateTime)
        let nowYear = new Date().getFullYear()
        for (let i = 0; i < 100; i++) {
            this.yearOp.push(nowYear - i)
        }
        for (let i = 1; i < 13; i++) {
            this.monthOp.push(i)
        }
    },
    methods: {
        initDate(val) {
            if (val) {
                this.dataObj.year = new Date(val).getFullYear()
                this.dataObj.month = new Date(val).getMonth() + 1
                this.dataObj.date = new Date(val).getDate()
            }
        },
        getDateOp() {
            let dayTotal
            switch (parseInt(this.dataObj.month)) {
                case 2:
                    if (parseInt(this.dataObj.year) % 4 == 0) {
                        dayTotal = 29
                    } else {
                        dayTotal = 28
                    }
                    break
                case 4: case 6: case 9: case 11:
                    dayTotal = 30
                    break
                default:
                    dayTotal = 31
                    break
            }
            for (let i = 1; i <= dayTotal; i++) {
                this.dateOp.push(i)
            }
        },
        yearOrMonthSel() {
            if (this.dateShow) {
                this.dateOp = []
                this.dataObj.date = ''
                this.$emit('getDate', null)
            } else {
                if (this.dataObj.year && this.dataObj.month) {
                    let dateTime = `${this.dataObj.year}/${this.dataObj.month}`
                    dateTime = new Date(dateTime).getTime()
                    this.$emit('getDate', dateTime)
                }
            }
        },
        dateSel() {
            if (this.dataObj.year && this.dataObj.month && this.dataObj.date) {
                let dateTime = `${this.dataObj.year}/${this.dataObj.month}/${this.dataObj.date}`
                dateTime = new Date(dateTime).getTime()
                this.$emit('getDate', dateTime)
            }
        }
    }
}
</script>
<style src="@/static/css/regist.css" scoped></style>
<style scoped>
.types {
    margin: 0 10px;
    width: 100px;
}

.types:first-child {
    margin-left: 0;
}
</style>